import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { toMomentString } from "config/util";
import { useDispatch, useSelector } from "react-redux";
import { toNumber } from "config/util";
import { initReactI18next, useTranslation } from "react-i18next";

export default function DenseTable({
  rows,
  set_price,
  accounts,
  active_self,
  active_other,
  scc,
  active_pair,
  active_price,
  rate_dollar,
  rate_yen,
  other_price,
  active_rate,
}) {
  // amount: "1"
  // price: "656692.77644213"
  // type: 1

  const askData = rows.filter((row) => row.type != 1);
  const bidData = rows.filter((row) => row.type == 1);

  // const askEmp = [...Array(5)].map((_, i) => {
  //   if (ask && ask[i]) return ask[i];
  //   return { residue_amount: "　" };
  // });

  const askEmp = [...Array(5 - askData.length)].map((_, i) => {
    return { residue_amount: "　" };
  });

  const bidEmp = [...Array(5 - bidData.length)].map((_, i) => {
    return { residue_amount: "　" };
  });

  const ask = askEmp.concat(askData);
  const bid = bidData.concat(bidEmp);

  // const bidEmp = [...Array(5)].map((_, i) => {
  //   if (bid && bid[i]) return bid[i];
  //   return { residue_amount: "　" };
  // });

  const maps = useSelector((state) => state.reduce_get_maps);
  const [t, i18n] = useTranslation();

  return (
    <TableContainer component={Paper}>
      {/* <Table className="table-striped" size="small" aria-label="a dense table"> */}
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {/* <TableRow className="gradient-black"> */}
            <TableCell
              align="center"
              // style={{ paddingLeft: 0, paddingRight: 0 ,color:"#00bcd4"}}
              style={{ padding: 0 }}
            >
              {t("Ask")} {t("数")} ({active_self})
            </TableCell>
            <TableCell
              align="center"
              // style={{ paddingLeft: 0, paddingRight: 0 ,color:"#fff"}}
              style={{ padding: 0 }}
            >
              {/* <span style={{ color: "#4caf50" }}>{"買い"}</span> */}
              {/* <span style={{ color: "#f44336" }}>{"売り"}</span> */}
              {active_self}/{active_other}
            </TableCell>
            <TableCell
              align="center"
              // style={{ paddingLeft: 0, paddingRight: 0 ,color:"#ff9800"}}
              style={{ padding: 0 }}
            >
              {t("Bid")} {t("数")} ({active_self})
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ask.map((row, idx) => (
            <TableRow
              key={idx}
              onClick={() => {
                set_price(row.price);
              }}
            >
              <TableCell align="center" style={{ padding: 0 }}>
                {toNumber(
                  row.residue_amount,
                  maps.coin_decimals[active_other].amount
                )}
              </TableCell>
              <TableCell align="center" style={{ padding: 0 }}>
                <span style={{ color: "#f44336" }}>
                  {toNumber(row.price, maps.coin_decimals[active_self].price)}
                </span>
              </TableCell>
              <TableCell align="center" style={{ padding: 0 }}>
                {""}
              </TableCell>
            </TableRow>
          ))}

          <TableRow
            key={0}
            onClick={() => {
              set_price(active_price);
            }}
            style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
            // color="#495057"
            // , #212529
          >
            <TableCell align="center" style={{ padding: 0 }}>
              <span className={active_rate < 0 ? "text-warning" : "text-info"}>
                <b>{active_rate < 0 ? "↓" : "↑"}</b>
                {active_rate}%
              </span>
            </TableCell>
            <TableCell align="center" style={{ padding: 0 }}>
              {toNumber(active_price, maps.coin_decimals[active_other].price)}
            </TableCell>

            <TableCell align="center" style={{ padding: 0 }}>
              {active_self === "SCP" && active_other === "SCC" ? (
                <>
                  <small>{"￥"}</small>
                  {scc}
                </>
              ) : (
                <>
                  <small>{"＄"}</small>
                  {active_price == 0
                    ? 0
                    : toNumber(active_price * rate_dollar, 5)}
                </>
              )}
              {/* <small>{"≈¥"}</small>
              {active_price == 0 ? 0 : toNumber(active_price * rate_yen, 6)} */}
            </TableCell>
          </TableRow>

          {bid.map((row, idx) => (
            <TableRow
              key={idx}
              onClick={() => {
                set_price(row.price);
              }}
            >
              <TableCell align="center" style={{ padding: 0 }}>
                {""}
              </TableCell>
              <TableCell align="center" style={{ padding: 0 }}>
                <span style={{ color: "#4caf50" }}>
                  {toNumber(row.price, maps.coin_decimals[active_self].price)}
                </span>
              </TableCell>
              <TableCell align="center" style={{ padding: 0 }}>
                {toNumber(
                  row.residue_amount,
                  maps.coin_decimals[active_other].amount
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
